import { NgModule } from '@angular/core';
import { IndexComponent } from './pages/index/index.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LandingPageRoutingModule } from './landing-page.routing';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        SharedModule,
        LandingPageRoutingModule
    ],
    exports: [],
    declarations: [IndexComponent],
    providers: [],
})
export class LandingPageModule { }
